import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactSection.css';
import contactImage from '../images/FLUX-2025-12-08-14_35_10.png';

function ContactSection() {
    const formRef = useRef(null);

    const [showConfirmation, setShowConfirmation] = useState(false);

    useEffect(() => {
        const fadeElements = document.querySelectorAll('.fade-in-cs');
        fadeElements.forEach((element, idx) => {
            setTimeout(() => {
                element.classList.add('cs-visible');
            }, idx * 200);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                'service_bfav1hb',
                'template_ttivkh2',
                formRef.current,
                'aJBFC8uDb4dLa5Bn4'
            )
            .then((result) => {
                console.log('EmailJS result:', result.text);
                setShowConfirmation(true);
            })
            .catch((error) => {
                console.error('EmailJS error:', error);
            });

        e.target.reset();
    };

    return (
        <section
            className="contact-section"
            id="contact"
            style={{ backgroundImage: `url(${contactImage})` }}
        >
            <div className="contact-overlay">
                <div className="contact-content">
                    <div className="fade-in-cs">
                        <h2>Contactez-Nous</h2>
                    </div>

                    <div className="contact-details fade-in-cs">
                        <p>
                        <strong>Téléphone:</strong><a href={"tel:0658084516"}> 06 58 08 45 16</a>
                        </p>
                        <p>
                            <strong>Email:</strong>{' '}
                            <a href="mailto:antiquaires.experts@gmail.com">antiquaires.experts@gmail.com</a>
                        </p>
                    </div>
                    <form
                        ref={formRef}
                        className="contact-form fade-in-cs"
                        onSubmit={handleSubmit}
                    >
                        <input
                            type="text"
                            name="name"
                            placeholder="Votre Nom"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Votre Email"
                            required
                        />
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Votre Téléphone"
                            required
                        />
                        <textarea
                            name="message"
                            placeholder="Votre Message"
                            required
                        ></textarea>
                        <button type="submit">Envoyer</button>
                    </form>

                    {showConfirmation && (
                        <div className="confirmation-message">
                            Votre message a été envoyé avec succès !
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default ContactSection;
